<template>
<div
                  id="ubie-banner"
                  style="display: inline-block"
                  data-ubie-href="https://sg.ubie.app/medical-institutions/drdanielwai"
                  data-banner-type="desktop-banner-m"
                  data-is-responsive
                ></div>
</template>

<script>
  export default {
    mounted() {
    //   if (localStorage.getItem('reloaded')) {
    //     // The page was just reloaded. Clear the value from local storage
    //     // so that it will reload the next time this page is visited.
    //     localStorage.removeItem('reloaded');
    //   } else {
    //       // Set a flag so that we know not to reload the page twice.
    //       localStorage.setItem('reloaded', '1');
    //       // location.reload();
    //     //   this.$forceUpdate();
    //   }
    },
  }
</script>